import { CategoryIcon, resolveCategoryForIcon, getCategoryBreadcrumb } from "../../../lib/categoryIcons";
import { getArticleStatus, STATUS_CLASSES } from "../../../lib/stockDisplay";
import { StockArticleActions } from "../../../components/StockArticleActions";

// Modèle 3 — Liste compacte : une ligne par article, la disposition la plus
// dense verticalement, pensée pour un usage rapide au téléphone.
export function CompactListView({ articles, categories, isTestMode, user, canEditAnyStockField, canTransfer, onEdit, onTransfer, onDelete, uploadsBase }) {
  return (
    <div className="rounded-xl border border-border bg-card overflow-hidden max-w-2xl mx-auto" data-testid="stock-view-liste">
      {articles.map((a) => {
        const s = getArticleStatus(a, isTestMode);
        const cls = STATUS_CLASSES[s.key];
        return (
          <div
            key={a.id}
            className="flex items-center gap-3 px-4 py-2.5 border-b border-border last:border-b-0 hover:bg-secondary/40 cursor-pointer group"
            onClick={() => canEditAnyStockField && onEdit(a)} data-testid={`stock-list-row-${a.id}`}
          >
            <div className="w-9 h-9 rounded-lg bg-secondary flex items-center justify-center overflow-hidden shrink-0">
              {a.photo_url ? (
                <img src={`${uploadsBase}${a.photo_url}`} alt={a.nom} className="w-full h-full object-cover" />
              ) : (
                <CategoryIcon category={resolveCategoryForIcon(categories, a.categorie)} uploadsBase={uploadsBase} size={16} className="text-muted-foreground" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">{a.nom}</p>
              <p className="text-[11px] text-muted-foreground truncate">
                {getCategoryBreadcrumb(categories, a.categorie)} · {a.code || a.id.slice(-6)} ·{" "}
                <span className={cls.badgeText}>{s.label}</span>
              </p>
            </div>
            <div className="text-right shrink-0">
              <p className="text-sm font-semibold font-mono">{Number(a.prix_ttc ?? a.prix ?? 0).toFixed(2)} €</p>
              <p className={`text-[11px] font-mono ${cls.text}`}>Qté: {a.quantite}</p>
            </div>
            <StockArticleActions
              article={a} user={user} canEditAnyStockField={canEditAnyStockField} canTransfer={canTransfer}
              onEdit={onEdit} onTransfer={onTransfer} onDelete={onDelete}
              className="flex gap-1 opacity-0 group-hover:opacity-100 shrink-0"
            />
          </div>
        );
      })}
      {articles.length === 0 && (
        <p className="p-6 text-center text-sm text-muted-foreground">Aucun article.</p>
      )}
    </div>
  );
}
